import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { MessageHandlerService } from "../../services/message-handler.service";
import { EventEmitter } from "@angular/core";
import { Notification, NotificationData } from "../data/notification";

@Injectable()
export class NotificationService extends NotificationData {
  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiCampaign: string;
  header: any;

  constructor(
    private http: HttpClient,
    private messageHandler: MessageHandlerService
  ) {
    super();
    this.api = environment.apiUrl;
  }

  async getNotifications() {
    try {
      let response = await this.http
        .get(this.api + "notification")
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async editNotification(id: string, notification: Notification) {
    try {
      let response = await this.http
        .put(this.api + "notification/"+id, notification)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }
}
